import React from 'react';
import SwimmingBlackCaiman from './BlackCaiman.jsx';
import SwimmingPeacockBass from './PeacockBass.jsx';
import SwimmingWolfFish from './WolfFish.jsx';
import SwimmingBicuda from './Bicuda.jsx';

// robust env flag (defaults ON)
const boolEnv = (key, def = true) => {
    const raw = process.env[key];
    if (raw == null) return def;
    const v = String(raw).trim().toLowerCase();
    if (['1', 'true', 'yes', 'on'].includes(v)) return true;
    if (['0', 'false', 'no', 'off', ''].includes(v)) return false;
    return def;
};

export default function RunsCreatures({
    zone,
    theme, // kept for parity
    onCreatureClick,
    highlightVersion,
}) {
    const isHighlighted = (ver) =>
        highlightVersion != null && String(ver) === String(highlightVersion);

    const showBlackCaiman = boolEnv('REACT_APP_SHOW_BLACK_CAIMAN', true);
    const showPeacockBass = boolEnv('REACT_APP_SHOW_PEACOCK_BASS', true);
    const showWolfFish = boolEnv('REACT_APP_SHOW_WOLF_FISH', true);
    const showBicuda = boolEnv('REACT_APP_SHOW_BICUDA', true);

    const v0 = zone?.versions?.[0];
    const v1 = zone?.versions?.[1];
    const v2 = zone?.versions?.[2];
    const v3 = zone?.versions?.[3];

    const handleClick = (v, name) => {
        if (onCreatureClick) onCreatureClick(v);
        else console.warn(`[RunsCreatures] onCreatureClick missing; clicked ${name}`, v);
    };

    return (
        <section className="relative w-full h-64 overflow-visible">
            {/* Black Caiman */}
            {showBlackCaiman && v0 && (
                <SwimmingBlackCaiman
                    width={170}
                    top="90%"
                    left="18%"
                    bobDuration="4s"
                    zIndex={22}
                    theme={theme}
                    highlight={isHighlighted(v0.versionNumber)}
                    onClick={() => handleClick(v0, 'BlackCaiman')}
                />
            )}

            {/* Peacock Bass */}
            {showPeacockBass && v1 && (
                <SwimmingPeacockBass
                    width={100}
                    swimDuration="30s"
                    zIndex={25}
                    highlight={isHighlighted(v1.versionNumber)}
                    onClick={() => handleClick(v1, 'PeacockBass')}
                />
            )}

            {/* Wolf Fish */}
            {showWolfFish && v2 && (
                <SwimmingWolfFish
                    width={120}
                    swimDuration="45s"
                    minTop={75}
                    maxTop={92}
                    zIndex={30}
                    highlight={isHighlighted(v2.versionNumber)}
                    onClick={() => handleClick(v2, 'WolfFish')}
                />
            )}
            {/* Bicuda */}
            {showBicuda && v3 && (
                <SwimmingBicuda
                    width={120}
                    swimDuration="65s"
                    minTop={80}
                    maxTop={95}
                    zIndex={35}
                    highlight={isHighlighted(v3.versionNumber)}
                    onClick={() => handleClick(v3, 'Bicuda')}
                />
            )}
        </section>
    );
}
